// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Dj4c","content":"styles_content__2p9x_","checkbox":"styles_checkbox__z6bLS","checkboxLabel":"styles_checkboxLabel__343xw"};